module.exports = __webpack_public_path__ + "static/media/missing_avatar.c52d9b30.svg";